<template>
  <div class="wrapper">
    <div class="wrapper">
      <nuxt-link event="" to="/" @click.native="toExperienceHome('/', 'Vexels')">
        <img
          :src="dynamicLogoOnExperience"
          class="vexels-logo"
          :alt="$t('main.header.logo.vexelsLogoAlt')"
          width="130"
          height="29"
        />
      </nuxt-link>
    </div>
    <div class="wrapper main-experience-container">
      <div :class="{ 'merch-active': merchActive }" class="wrapper experience-container">
        <nuxt-link
          :to="$urlBuilder('merch-home')"
          event=""
          @click.native="toExperienceHome($urlBuilder('merch-home'), 'Merch')"
        >
          <span
            :class="{ 'merch-active-text': merchActive }"
            class="experience-text merch"
            :style="{ color: getHeaderTextColor }"
            >{{ $t('main.header.tags.forMerch') }}</span
          >
        </nuxt-link>
      </div>
      <div :class="{ 'design-active': designActive }" class="wrapper experience-container">
        <nuxt-link
          :to="$urlBuilder('design-home')"
          event=""
          @click.native="toExperienceHome($urlBuilder('design-home'), 'Design')"
        >
          <span
            :class="{ 'design-active-text': designActive }"
            class="experience-text design"
            :style="{ color: getHeaderTextColor }"
            >{{ $t('main.header.tags.design') }}</span
          >
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'LogoSection',
  data: () => {
    return {
      designActive: false,
      merchActive: false
    };
  },
  computed: {
    ...mapGetters('config', ['getHeaderTextColor']),
    ...mapGetters('experience', ['getExperience', 'getMerch', 'getDesign']),
    dynamicLogoOnExperience() {
      switch (this.getExperience) {
        case this.getMerch:
          return 'https://cdn.vexels.com/img/logo-variants/merch-logo-variant.svg';
        case this.getDesign:
          return 'https://cdn.vexels.com/img/logo-variants/design-logo-variant.svg';
        default:
          return 'https://cdn.vexels.com/img/logo-variants/default-logo-variant.svg';
      }
    }
  },
  watch: {
    $route() {
      this.designActive = this.checkDesignActive();
      this.merchActive = this.checkMerchActive();
    }
  },
  methods: {
    checkDesignActive() {
      return this.$urlNameChecker('design');
    },
    checkMerchActive() {
      return this.$urlNameChecker('merch');
    },
    toExperienceHome(url, name) {
      this.$ga.event('Top Menu', `Click Button ${name} Top Menu`, this.$route.fullPath);
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.design:hover {
  color: $designColor !important;
}
.design-active-text {
  color: $designColor !important;
}
.design-active {
  border-bottom: 2px solid $designColor;
  border-top: 2px solid transparent;
}
.experience-container {
  height: 100%;
  box-sizing: border-box;
}
.experience-text {
  color: #545454;
  font-size: 15px;
  padding: 13px;
  font-family: 'Poppins', sans-serif;
  @include xl {
    font-size: 15px;
  }
}
.main-experience-container {
  margin-left: 15px;
  height: 100%;
}
.merch:hover {
  color: $merchColor !important;
}
.merch-active-text {
  color: $merchColor !important;
}
.merch-active {
  border-bottom: 2px solid $merchColor;
  border-top: 2px solid transparent;
}
.vexels-logo {
  width: 130px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  height: 100%;
  @include xl {
    width: 90px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
